import { render, staticRenderFns } from "./EditProductSize.vue?vue&type=template&id=37dd3b22"
import script from "./EditProductSize.vue?vue&type=script&lang=js"
export * from "./EditProductSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports